import { render, staticRenderFns } from "./OidcCallbackErrorPage.vue?vue&type=template&id=42bb87d0"
import script from "./OidcCallbackErrorPage.vue?vue&type=script&lang=js"
export * from "./OidcCallbackErrorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports